import type { OrgMembership } from '@/backend/contracts';
import { Permission, type PermissionValue, type Role, type UserProfile } from '../auth/types';

export function canAccessProjectViaOrgAdmin(
    user: Pick<UserProfile, 'uid'> | null | undefined,
    orgId: string | null | undefined,
    memberships: readonly OrgMembership[],
): boolean {
    return Boolean(user?.uid && orgId && memberships.some(membership => (
        membership.orgId === orgId
        && membership.status === 'active'
        && (membership.role === 'owner' || membership.role === 'admin')
    )));
}

export function getLayoutUserPermissions(
    user: Pick<UserProfile, 'isSuperAdmin'> | null | undefined,
    role: Role | null | undefined,
    canAccessAsOrgAdmin: boolean,
): PermissionValue[] {
    if (user?.isSuperAdmin) {
        return Object.values(Permission);
    }

    return [...new Set<PermissionValue>([
        ...(role?.permissions || []),
        ...(canAccessAsOrgAdmin
            ? [Permission.EDIT_NOTES, Permission.VIEW_ACTION_ITEMS, Permission.EDIT_ACTION_ITEMS]
            : []),
    ])];
}
